import { Server, Network } from 'tokend-js-sdk'
import config from '@conf'

export function initHorizonServer (networkId, headers = {}) {
  Network.use(new Network(networkId))
  return new Server(config.HORIZON_SERVER, { allowHttp: true, headers })
}



// WEBPACK FOOTER //
// ./src/js/helpers/server.helper.js